import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import KoobButton from './KoobButton';

/** The 404: an unknown address, or a record that does not exist. Sits inside
 * the app's layout, so the navigation stays. */
export default function KoobNotFound() {
  const { t } = useTranslation('notFound');

  return (
    <div className="flex min-h-[70vh] flex-wrap items-center justify-center gap-x-[72px] gap-y-10 px-6 py-10">
      {/* The B, its lower half fallen off. */}
      <svg
        viewBox="20 10 70 80"
        aria-hidden
        className="h-[220px] w-auto sm:h-[300px]"
      >
        <path className="fill-k-h" d="M28 22H54A13 13 0 0 1 54 48H28Z" />
        <path
          className="fill-k-orange"
          transform="rotate(14 44 80)"
          d="M34 58H66A13 13 0 0 1 66 84H34Z"
        />
        <path d="M24 88H84" className="stroke-navy-200" strokeWidth={1.5} />
      </svg>
      <div className="flex max-w-[440px] flex-col gap-4">
        <p className="m-0 text-xs font-semibold uppercase tracking-[0.08em] text-orange-700">
          {t('overline')}
        </p>
        <h1 className="m-0 text-[40px] font-bold leading-[48px] tracking-[-0.02em] text-k-h">
          {t('title')}
        </h1>
        <p className="m-0 text-base leading-[26px] text-k-body">
          {t('description')}
        </p>
        <div className="mt-2">
          <KoobButton asChild variant="primary">
            <Link to="/" className="no-underline">
              {t('home')}
            </Link>
          </KoobButton>
        </div>
      </div>
    </div>
  );
}
